import { stripeTitle } from './StripeStore';

export const updateStripeTitle = (value) => stripeTitle.update(oldValue => value);
